import { isGlobalFeatureEnabled } from 'owa-feature-flags/lib/utils/isFeatureEnabled';

/**
 * Checks once per entry-point call whether to use the native HTML Sanitizer API.
 * The result should be captured and passed down — inner functions must not re-check the flight.
 */
export function shouldUseNativeSanitizer(): boolean {
    return (
        isGlobalFeatureEnabled('fwk-use-native-html-sanitizer', true) &&
        typeof globalThis.Sanitizer !== 'undefined' &&
        typeof HTMLElement.prototype.setHTML === 'function'
    );
}
